const ContainerHeader = ({ title, id, icon = "", partnerName = "" }) => {
  
  return (
    <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
      <h3 className="title mb-3 mb-sm-0">
        <i className={`zmdi ${icon} zmdi-hc-fw`}></i>
        {title}
      </h3>
      {id && <h6 className="title mb-3 mb-sm-0"># {id}</h6>}
      {partnerName && <h3 className="title mb-3 mb-sm-0"><i className="zmdi zmdi-account zmdi-hc-fw"></i> {partnerName}</h3>}
    </div>
  );
};

export default ContainerHeader;